import "./parsers/index.mjs";
//# sourceMappingURL=index.mjs.map
